export default function(nga, admin) {
    let extend = admin.getEntity('invoice');
    let entity = admin.getEntity('payment')
        //.updateMethod('patch')
        .label('payment')
        .url(function(entity, view, id) {
            if(id)
                return 'invoice/' + encodeURIComponent(id);

            return 'invoice';
        });

    let pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    let fields = Object.assign([], extend.listView().fields());
    fields.push(nga.field('payment_relation').label('INVOICE').map(function (value, entry) {
        return entry['payment_relation.numeration'];
    }).template('<entity-edit type="\'invoice\'" id="entry.values[\'payment_relation.id\']" text="value"></entity-edit>'));

    entity.listView()
        .fields(fields)
        .url(extend.listView().url())
        .permanentFilters({
            payment: true
        })
        .listActions(['<invoice-download entry="entry" entity="entity"/>', '<invoice-resend entry="entry" entity="entity"/>','edit', 'delete'])
        .filters(extend.listView().filters());

    let fields_edit = Object.assign([], extend.editionView().fields());
    fields_edit.push(nga.field('payment_relation', 'reference')
        .singleApiCall(function () {
            return { 'payment': false };
        })
        .map(function(value, entry) {
            return entry['payment_relation.id'];
        })
        .targetEntity(nga.entity('invoice').url('invoices'))
        .targetField(nga.field('numeration'))
        .perPage(0));


    entity.editionView().fields(fields_edit);


    entity.creationView().fields(
        entity.editionView().fields()
    );

    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/payment/config.js
 **/